import { REST_API } from '../../constants/restApiUrls';
import HttpConnection from '../../utils/http-connection';

/**
 * 検索条件からシステムユーザー情報を取得する
 *
 * @param {object} serachConditions
 */
export function getDatas(serachCondition) {
  const httpConnection = new HttpConnection();

  return httpConnection
    .get(REST_API.USER_SETTING.SYSTEM_USER.SYSTEM_USERS, serachCondition)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error));
}

/**
 * コンボボックス用の一覧を取得する
 *
 * @param {object} serachConditions
 */
export function getSelects() {
  const httpConnection = new HttpConnection();

  return httpConnection
    .get(REST_API.USER_SETTING.SYSTEM_USER.SELECT_LIST)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error));
}

/**
 * 削除処理
 *
 * @param {*} deleteList
 */
export function deleteSystemUser(values) {
  const httpConnection = new HttpConnection();

  return httpConnection
    .deletes(REST_API.USER_SETTING.SYSTEM_USER.SYSTEM_USERS, values)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error));
}
